import styled from 'styled-components';

const BrowseTitle = styled.h1`
  font-weight: 900;
  letter-spacing: 1px;
  font-family: "Avenir Black", "Arial Black", sans-serif;
  font-size: ${({ fontSize }) => fontSize || '13px'};
  margin: 0;
  line-height: initial;
`;

export default BrowseTitle;
